export ChangePasswordForm from './ChangePasswordForm'
export ContactForm from './ContactForm'
export CreateOrgForm from './CreateOrgForm'
export EditOrgForm from './EditOrgForm'
export EditUserForm from './EditUserForm'
export ForgotPasswordForm from './ForgotPasswordForm'
export LoginForm from './LoginForm'
export RegisterForm from './RegisterForm'
export ResetPasswordForm from './ResetPasswordForm'



// WEBPACK FOOTER //
// ./src/components/forms/index.js